/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientBehaviorModel } from '../../models/patient-behavior-model';

export interface GetPatientBehaviors$Params {
  patientID?: number;
  onlyActive?: boolean;
}

export function GetPatientBehaviors(http: HttpClient, rootUrl: string, params?: GetPatientBehaviors$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PatientBehaviorModel>>> {
  const rb = new RequestBuilder(rootUrl, GetPatientBehaviors.PATH, 'get');
  if (params) {
    rb.query('patientID', params.patientID, {});
    rb.query('onlyActive', params.onlyActive, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PatientBehaviorModel>>;
    })
  );
}

GetPatientBehaviors.PATH = '/api/Staff/GetPatientBehaviors';
